<div class="acc-support-unavailable" role="status">
  <div class="acc-support-unavailable-icon">
    <acc-icon name="support" size="2x"/>
  </div>
  <p class="acc-support-unavailable-text">{{ 'exception.support.unavailable'|translate }}</p>
</div>
